export default __webpack_public_path__ + "static/media/(10).3e1bf0e2.jpg";